<template>
  <div>
    <div class="p-3 mb-6">
      <div
        class="flex flex-row gap-4 p-4 items-center justify-center"
        v-if="getDataTechnical().length"
      >
        <div
          class="w-full md:w-1/2 bg-white rounded-lg shadow p-3"
          v-if="false"
        >
          <div class="flex items-center space-x-4 mb-2">
            <h1 class="text-2xl font-semibold mb-2">Reperaciones por</h1>
            <el-select
              class="w-48"
              v-model="repairsType"
              placeholder="Select an option"
              size="small"
            >
              <el-option label="Reperaciones" value="repairs"></el-option>
              <el-option label="Productos" value="products"></el-option>
            </el-select>
          </div>
        </div>
        <div
          class="sm:w-full md:w-full w-1/2 max-w-4xl bg-white rounded-lg shadow-lg hover:shadow-2xl border border-gray-200 transform hover:-translate-y-1 transition duration-200 p-6 flex flex-col items-center justify-center"
          id="report-statics"
        >
          <div class="flex items-center space-x-4 mb-2">
            <h1 class="text-lg font-semibold">Rendimiento por Técnico</h1>
            <el-select
              class="w-48"
              v-model="orderType"
              placeholder="Select an option"
              size="small"
            >
              <el-option label="Reparaciones" value="repairs"></el-option>
              <el-option label="Productos" value="sales"></el-option>
            </el-select>
          </div>
          <Chart :options="chartOrderTypeOptions" />
        </div>

        <div
          class="sm:w-full w-1/2 max-w-4xl bg-white rounded-lg shadow-lg hover:shadow-2xl border border-gray-200 transform hover:-translate-y-1 transition duration-200 p-6 flex flex-col items-center justify-center"
        id="report-top5-clients">
          <h1 class="text-2xl font-semibold mb-2">
            Top 5 Clientes que Más Han Vuelto
          </h1>
          <Chart :options="chartTopClients" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numbers from "@/utils/numbers";
import { Chart } from "highcharts-vue";
export default {
  name: "StatisticsReports",
  components: {
    Chart,
  },
  props: {
    topClients: {
      type: Array,
      required: true,
    },
    technicalPerformance: {
      type: Array,
      required: true,
    },
    widthChart: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      orderType: "repairs",
      repairsType: "type",
      chartTopClients: {
        chart: {
          type: "column",
          height: 350,
          width: 450,
          reflow: true,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.topClients.map((client) => client.clientName),
          title: {
            text: "Clientes",
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Número de Ordenes",
          },
        },
        tooltip: {
          shared: true,
          valueSuffix: "",
        },
        series: [
          {
            name: "Número de Ordenes",
            data: this.topClients.map((client) => client.totalOrders),
            color: "#D4A017",
          },
        ],
      },
    };
  },
  mounted() {},
  computed: {
    chartOrderTypeOptions() {
      return {
        chart: {
          type: "column",
          height: 350,
          width: 450,
          reflow: true,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.getNameTechnical(),
          title: {
            text: "Técnicos",
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Total",
          },
        },
        tooltip: {
          shared: true,
          valueSuffix: "",
        },
        series: [
          {
            name: "Total",
            data: this.getDataTechnical(),
            color: "#a855f7",
          },
        ],
      };
    },
  },
  methods: {
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    getNameTechnical() {
      return this.technicalPerformance.map((item) => item.technicianName);
    },
    getDataTechnical() {
      if (this.orderType === "repairs") {
        return this.technicalPerformance.map((item) => item.totalOrders);
      } else {
        return this.technicalPerformance.map((item) => item.totalSales);
      }
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
